/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KPIAllOfValues } from './KPIAllOfValues';
import {
    KPIAllOfValuesFromJSON,
    KPIAllOfValuesFromJSONTyped,
    KPIAllOfValuesToJSON,
    KPIAllOfValuesToJSONTyped,
} from './KPIAllOfValues';

/**
 * 
 * @export
 * @interface KPI
 */
export interface KPI {
    /**
     * 
     * @type {string}
     * @memberof KPI
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof KPI
     */
    unit?: string;
    /**
     * 
     * @type {Array<KPIAllOfValues>}
     * @memberof KPI
     */
    values: Array<KPIAllOfValues>;
}

/**
 * Check if a given object implements the KPI interface.
 */
export function instanceOfKPI(value: object): value is KPI {
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function KPIFromJSON(json: any): KPI {
    return KPIFromJSONTyped(json, false);
}

export function KPIFromJSONTyped(json: any, ignoreDiscriminator: boolean): KPI {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'values': ((json['values'] as Array<any>).map(KPIAllOfValuesFromJSON)),
    };
}

export function KPIToJSON(json: any): KPI {
    return KPIToJSONTyped(json, false);
}

export function KPIToJSONTyped(value?: KPI | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'unit': value['unit'],
        'values': ((value['values'] as Array<any>).map(KPIAllOfValuesToJSON)),
    };
}

